import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { fetchLinkOffer } from "./api";
import { readLink, readLinkCreative, rememberLink } from "./attribution";

/**
 * Mounted once in App. Remembers ?link=<slug> for the link's attribution
 * window, and attributes an already signed-in account to it (first link
 * wins; the database decides if that makes them eligible for anything).
 */
export function LinkCapture() {
  const { search } = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    const q = new URLSearchParams(search);
    const slug = q.get("link")?.toLowerCase();
    if (!slug) return;
    const creative = q.get("lc")?.toLowerCase() ?? null;
    const variant = q.get("lv")?.toLowerCase() ?? null;
    void fetchLinkOffer(slug).then((offer) => {
      if (offer) rememberLink(slug, offer.attribution_days, Date.now(), creative, variant);
    });
  }, [search]);

  useEffect(() => {
    if (!user) return;
    const q = new URLSearchParams(search);
    const slug = q.get("link")?.toLowerCase() || readLink();
    if (!slug) return;
    const creative = q.get("lc")?.toLowerCase() || readLinkCreative();
    void (supabase as any).rpc("claim_link_attribution", { _slug: slug, _creative: creative });
  }, [user?.id, search]);

  return null;
}
